module.exports = __webpack_public_path__ + "img/paypal.85fee7a6.svg";